import React from 'react';
import './styles/StarRating.css';

const StarRating = ({ rating, size = 'medium' }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  
  // Apply size class based on prop
  const sizeClass = size === 'small' ? 'small' : 
                    size === 'large' ? 'large' : '';
  
  for (let i = 1; i <= 5; i++) {
    if (i <= fullStars) {
      stars.push(<span key={i} className={`star filled ${sizeClass}`}>★</span>);
    } else if (i === fullStars + 1 && hasHalfStar) {
      stars.push(<span key={i} className={`star half-filled ${sizeClass}`}>★</span>);
    } else {
      stars.push(<span key={i} className={`star ${sizeClass}`}>★</span>);
    }
  }
  
  return <div className="star-rating">{stars}</div>;
};

export default StarRating;
